// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3mjT3","emails":"CreateEditClinics_emails__1BG7i","emailTagLabel":"CreateEditClinics_emailTagLabel__1EuC9"};